import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/pro-regular-svg-icons";
import { StatusChip } from "@/components/status-chip";
import { TaskLabel } from "@/components/patient-tasks/task-label";
import { formatShortDate } from "@/utils/format";
import { isAiraReminder } from "@/utils/aira";
import { useTaskDetailStore } from "@/stores/task-detail";
import { getTaskDisplayProps, countLinkedResources } from "../get-task-status";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** A single reminder card row in the patient tasks list. */
export function TaskItem(_ref) {
  var _reminder$labels$0$na, _reminder$labels$, _ref2, _reminder$owned_by_in, _reminder$owned_by_in2, _reminder$owned_by_in3;
  var reminder = _ref.reminder,
    onSelect = _ref.onSelect;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _getTaskDisplayProps = getTaskDisplayProps(reminder),
    intent = _getTaskDisplayProps.intent,
    label = _getTaskDisplayProps.label;
  var attachmentCount = countLinkedResources(reminder.linked_resources);
  var taskLabel = (_reminder$labels$0$na = (_reminder$labels$ = reminder.labels[0]) === null || _reminder$labels$ === void 0 ? void 0 : _reminder$labels$.name) !== null && _reminder$labels$0$na !== void 0 ? _reminder$labels$0$na : "TASK";
  var isAira = isAiraReminder(reminder);
  var ownerName = (_ref2 = (_reminder$owned_by_in = (_reminder$owned_by_in2 = reminder.owned_by_info) === null || _reminder$owned_by_in2 === void 0 ? void 0 : _reminder$owned_by_in2.name) !== null && _reminder$owned_by_in !== void 0 ? _reminder$owned_by_in : (_reminder$owned_by_in3 = reminder.owned_by_info) === null || _reminder$owned_by_in3 === void 0 ? void 0 : _reminder$owned_by_in3.email) !== null && _ref2 !== void 0 ? _ref2 : "";
  var isActive = useTaskDetailStore(function (s) {
    var _s$reminder;
    return ((_s$reminder = s.reminder) === null || _s$reminder === void 0 ? void 0 : _s$reminder.id) === reminder.id;
  });
  var isOpen = useTaskDetailStore(function (s) {
    var _s$reminder2;
    return ((_s$reminder2 = s.reminder) === null || _s$reminder2 === void 0 ? void 0 : _s$reminder2.id) === reminder.id && s.status === "open";
  });
  var itemRef = useRef(null);
  useEffect(function () {
    var _itemRef$current;
    if (isActive) (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.scrollIntoView({
      block: "nearest"
    });
  }, [isActive]);
  return /*#__PURE__*/React.createElement("li", {
    ref: itemRef,
    className: "mb-3 rounded-sds-300 border overflow-hidden ".concat(isActive ? "border-sds-brand-default" : "border-sds-base-default")
  }, /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-item-".concat(reminder.id),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_ITEM, {
        taskId: reminder.id
      });
      onSelect === null || onSelect === void 0 || onSelect(reminder);
    },
    className: "w-full text-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-5 space-y-4 ".concat(isOpen ? "bg-sds-brand-tertiary" : "bg-sds-base-default")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-2"
  }, /*#__PURE__*/React.createElement(TaskLabel, {
    label: taskLabel,
    isAira: isAira
  }), /*#__PURE__*/React.createElement(StatusChip, {
    intent: intent,
    label: label
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-default break-all ".concat(reminder.resolved ? "line-through" : "")
  }, reminder.title || reminder.context), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 text-style-label-base text-sds-base-tertiary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faUserCircle,
    className: "w-3 h-3"
  }), /*#__PURE__*/React.createElement("span", null, ownerName)), /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-base text-sds-base-tertiary shrink-0"
  }, t("due_on"), " ", formatShortDate(reminder.remind_after))))), attachmentCount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-5 py-4 bg-sds-base-secondary border-t border-sds-base-default text-style-label-base text-sds-base-tertiary"
  }, t("label.records"), ": ", attachmentCount, " ", t("files")));
}